import React, {
  useCallback,
  useMemo,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Menu } from 'antd';

import { ReactComponent as DownloadIcon } from '../assets/icons/download.svg';
import TimecardHeaderButton from './TimecardHeaderButton';
import { EXPORT_TYPE_EXCEL, EXPORT_TYPE_PDF } from './timecard.helpers';
import ExcelIcon from '../common/icons/files/ExcelIcon';
import PDFIconSmall from '../common/icons/files/PDFIconSmall';

import Colors from '../constants/Colors';

const ICON_WIDTH = 13;
const ICON_HEIGHT = 16;

const menuItemStyle = {
  fontFamily: 'Open Sans, Arial, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: '18px',
  letterSpacing: 0,
  color: Colors.GRAY_950,
};

function TimecardsDownloadButton({
  onExport,
}) {
  const [visible, setVisible] = useState(false);
  const blockClose = useRef(false);
  const blockCloseTimer = useRef();
  const closeMenu = useCallback(() => setVisible(false), []);

  const onVisibleChange = (next) => {
    if (!next && blockClose.current) return;
    if (next) {
      blockClose.current = true;
      window.clearTimeout(blockCloseTimer.current);
      blockCloseTimer.current = window.setTimeout(() => {
        blockClose.current = false;
      }, 300);
    }
    setVisible(next);
  };

  const menu = useMemo(() => (
    <Menu
      className="timecards-download-menu"
      onClick={closeMenu}
      style={{
        borderRadius: 6,
        border: `1px solid ${Colors.GRAY_200}`,
      }}
    >
      <Menu.Item key="export-to-excel" onClick={onExport(EXPORT_TYPE_EXCEL)}>
        <span className="timecards-download-menu-label" style={menuItemStyle}>
          <ExcelIcon width={ICON_WIDTH} height={ICON_HEIGHT} />
          Export to Excel
        </span>
      </Menu.Item>
      <Menu.Item key="export-to-pdf" onClick={onExport(EXPORT_TYPE_PDF)}>
        <span className="timecards-download-menu-label" style={menuItemStyle}>
          <PDFIconSmall width={ICON_WIDTH} height={ICON_HEIGHT} />
          Export to PDF
        </span>
      </Menu.Item>
    </Menu>
  ), [closeMenu, onExport]);

  return (
    <Dropdown
      visible={visible}
      onVisibleChange={onVisibleChange}
      trigger={['click']}
      placement="bottomLeft"
      overlay={menu}
    >
      <span style={{ display: 'inline-flex' }}>
        <TimecardHeaderButton
          onClick={(event) => event.preventDefault()}
          onMouseDown={(event) => event.preventDefault()}
        >
          <DownloadIcon />
        </TimecardHeaderButton>
      </span>
    </Dropdown>
  );
}

TimecardsDownloadButton.propTypes = {
  onExport: PropTypes.func.isRequired,
};

export default TimecardsDownloadButton;
